import { CheckoutStep } from '@/types';
import { PAGENAME, STEPS } from './checkout';

export const CHECKOUT_STEPS: CheckoutStep[] = [{
  id: 0,
  url: STEPS.CART,
  pageName: PAGENAME.CART,
  tKey: 'cart',
  publicStep: true,
  hideProgress: true,
  hideReturn: true
}, {
  id: 1,
  url: STEPS.LOGIN,
  pageName: PAGENAME.LOGIN,
  tKey: 'login',
  publicStep: true,
  hideSummary: true,
  hideProgress: true,
  hideEspot: true
}, {
  id: 2,
  url: STEPS.SHIPPING_ADDRESS,
  pageName: PAGENAME.SHIPADDRESS,
  tKey: 'shippingAddress',
  noEmptyCart: true,
  showStep: true,
  addrStep: true
}, {
  id: 3,
  url: STEPS.BILLING_ADDRESS,
  pageName: PAGENAME.BILLADDRESS,
  tKey: 'billingAddress',
  pKey: 'shippingAddress',
  hideStep: true,
  noEmptyCart: true
}, {
  id: 4,
  url: STEPS.SHIPPING_MODE,
  pageName: PAGENAME.SHIPMODE,
  tKey: 'shipMode',
  noEmptyCart: true,
  showStep: true
}, {
  id: 5,
  url: STEPS.REVIEW,
  pageName: PAGENAME.REVIEW,
  tKey: 'cartReview',
  noEmptyCart: true,
  showStep: true,
  checkAddress: true
}, {
  id: 6,
  url: STEPS.PAYMODE,
  pageName: PAGENAME.PAYMODE,
  tKey: 'payMode',
  payStep: true,
  noEmptyCart: true,
  showStep: true,
  hideEspot: true,
  checkAddress: true
}, {
  id: 7,
  url: STEPS.REPORT,
  pageName: PAGENAME.REPORT,
  tKey: 'report',
  hideStep: true,
  hideReturn: true,
  hideEspot: true,
  reportStep: true,
  readOnly: true
}];
